/**
 * Shared dummy data for landing page demo components
 */

export interface DummyIntegration {
  id: string;
  name: string;
  status?: string;
}

export const dummyIntegrations: DummyIntegration[] = [
  {
    id: "gmail",
    name: "Gmail",
  },
  {
    id: "googlecalendar",
    name: "Google Calendar",
  },
  {
    id: "googledocs",
    name: "Google Docs",
  },
  {
    id: "notion",
    name: "Notion",
  },
  {
    id: "googlesheets",
    name: "Google Sheets",
  },
  {
    id: "twitter",
    name: "Twitter",
  },
  {
    id: "linkedin",
    name: "LinkedIn",
  },
  {
    id: "slack",
    name: "Slack",
  },
  {
    id: "github",
    name: "GitHub",
  },
  {
    id: "asana",
    name: "Asana",
  },
  {
    id: "trello",
    name: "Trello",
  },
  {
    id: "zoom",
    name: "Zoom",
  },
  {
    id: "googlemeet",
    name: "Google Meet",
  },
  {
    id: "microsoft_teams",
    name: "Microsoft Teams",
  },
  {
    id: "linear",
    name: "Linear",
  },
  {
    id: "todoist",
    name: "Todoist",
  },
  {
    id: "googletasks",
    name: "Google Tasks",
  },
  {
    id: "clickup",
    name: "ClickUp",
  },
  {
    id: "hubspot",
    name: "HubSpot",
  },
  {
    id: "airtable",
    name: "Airtable",
  },
  {
    id: "reddit",
    name: "Reddit",
  },
  {
    id: "instagram",
    name: "Instagram",
  },
  {
    id: "google_maps",
    name: "Google Maps",
  },
];
